import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import {map, take} from 'rxjs/operators';
import {FirebaseService} from './firebase/firebase.service';
import {UserStatusService} from './user-status/user-status.service';
import {Router} from '@angular/router';
import {IUser} from '../core/interfaces/user';
import {Observable} from 'rxjs';
import {TenantService} from '../core/tenant/tenant.service';

@Injectable({
  providedIn: 'root'
})
export class SupervisorsService {
  superUser;

  constructor(private afs: AngularFirestore,
              private firebaseService: FirebaseService,
              private router: Router,
              private userStatus: UserStatusService,
              private tenant: TenantService,
  ) {
    this.superUser = this.tenant.support.defaultSuperUserProfile;
  }

  getAllSupervisors(isProfilePage?) {
    return this.afs.collection('users', ref => ref.where('role', '==', 'supervisor'))
      .valueChanges()
      .pipe(
        map((users) => {
          if (isProfilePage){
            users.push(this.superUser);
          }
          return users.map((user: any) => {
            return {
              id: user.id,
              email: user.email,
              name: user.displayName? user.displayName : 'Supervisor',
              status: user.status,
              lastSeen: user.lastSeen,
              pendingList: user.pendingList ? user.pendingList : [],
              photoURL: user.photoURL ? user.photoURL : null,
              lastLogin: user.lastLogin
            }
          })
        })
      )
  }
  getSupervisorForActivityPage() {
    return this.afs.collection('users', ref => ref.where('role', '==', 'supervisor')).valueChanges()
  }

  getAllEEGeniusUsers() {
    return this.afs.collection('users', ref => ref.where('EEGeniusUser', '==', true))
      .get()
      .pipe(
        map(snapshot => snapshot.docs.map(doc => doc.data()))
      )
  }

  getMySupervisors(id) {
    return this.afs.collection('users', db => db.where('allowedSupervisors', 'array-contains' , id))
      .get()
      .pipe(
        map(snapshot => snapshot.docs.map(doc => doc.data()))
      )
  }

  getAllUsers() {
    return this.afs.collection('users')
      .valueChanges()
      .pipe(
        map((users) => {
          return users;
        })
      )
  }

  //  handleAllUserRecords() {
  //    return this.afs.collection('users', ref => ref.where('EEGeniusUser', '==', true)).valueChanges();
  // }
  handleAllUserRecords() {
    return this.afs.collection('users', ref => ref.where('EEGeniusUser', '==', true))
      .get()
      .pipe(
        map(snapshot => snapshot.docs.map(doc => doc.data()))
      )
  }

  triggerUserStatus() {
    document.onvisibilitychange = (e) => {
      if (document.visibilityState === 'hidden' && this.router.url !== '/remote-training') {
        this.userStatus.setUserOffline().subscribe(() => {});
      }
      if (document.visibilityState === 'visible' && this.router.url !== '/remote-training') {
        this.userStatus.setUserOnline();
      }
    }
  }
}
